import { getWorkspaceIdFromCurrentUrl, useCurrentWorkspace } from '@/context/current-workspace';
import { generatePath } from '@/services/router/generate-path';
import { Link } from '@customerio/pluma-components/react';
import { Navigate } from 'react-router-dom';
import { AuditLogsPageContainer } from '@/features/audit-logs/components/audit-logs-page-container';

export const WorkspaceAuditLogs = () => {
  const workspaceId = getWorkspaceIdFromCurrentUrl();
  const currentWorkspace = useCurrentWorkspace();
  const workspaceName = currentWorkspace?.name ?? '';
  const pageTitle = workspaceName !== '' ? `${workspaceName} Audit Logs` : 'Audit Logs';

  if (workspaceId == null || workspaceId <= 0) {
    return <Navigate to="/settings" replace={true} />;
  }

  return (
    <AuditLogsPageContainer
      context="workspace"
      contextId={workspaceId}
      workspaceId={workspaceId}
      breadcrumbs={[
        { text: 'Workspace settings', href: generatePath('/workspaces/:workspaceId/settings', { workspaceId }) },
        { text: 'Audit logs' },
      ]}
      pageTitle={pageTitle}
      pageDescription={
        <>
          View audit logs for this workspace to track changes and activities. Looking for account-level changes like
          team members or roles? <Link href="/settings/audit-logs">View Account Audit Logs</Link>
        </>
      }
      backUrlBase={generatePath('/workspaces/:workspaceId/settings/audit-logs', { workspaceId })}
      feedbackFeature="Workspace Audit Logs"
    />
  );
};
